// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__jl3wS","content":"SectionHero_content__T5mrD","visuallyHidden":"SectionHero_visuallyHidden__HjEzc"};